import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { debounceTime } from 'rxjs/operators';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class BannerService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'banner';
    this.token = new Login();
  }

  all() {
    return this.http.get<Object[]>(this.url);
  }

  criar(banner: any) {
    return this.http.post<Object[]>(this.url, banner, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
  
  excluir(idmensagem: any) {
    return this.http.delete<Object[]>(this.url + '/' + idmensagem, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  atualizar(banner: any) {
    return this.http.put<Object[]>(this.url + '/' + banner.idmensagem, banner, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }


  detalhar(idmensagem: any) {
    return this.http.get<Object[]>(this.url + '/' + idmensagem, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
}
